import { apiSlice } from './apiSlice';

const api = apiSlice.injectEndpoints({
  endpoints: builder => ({
    listWikiKeys: builder.query({
      query: arg => ({
        url: 'wiki/wiki-keys/',
        method: 'GET',
        params: arg,
      }),
      providesTags: ['wikiKeys'],
    }),

    searchWikiKeysWithClients: builder.query({
      query: params => ({
        url: 'wiki/wiki-keys-search/',
        method: 'GET',
        params,
      }),
      providesTags: ['wikiKeys'],
    }),

    searchWikiKeys: builder.query({
      query: arg => {
        return {
          url: `wiki/wiki-keys/`,
          method: 'GET',
          params: arg,
        };
      },
      providesTags: ['wikiKeys'],
    }),

    saveWikiKes: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-keys/`,
          method: 'POST',
          body: arg,
        };
      },
      invalidatesTags: ['wikiKeys'],
    }),

    updateWikiKey: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-keys/${arg.id}/`,
          method: 'PATCH',
          body: arg.frm,
        };
      },
      invalidatesTags: ['wikiKeys'],
    }),

    deleteWikiKey: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-keys/${arg.id}/`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['wikiKeys'],
    }),
  }),
});

export const { useSearchWikiKeysWithClientsQuery, useDeleteWikiKeyMutation, useUpdateWikiKeyMutation, useSaveWikiKesMutation, useSearchWikiKeysQuery } = api;
